<template>
<div>
  <component :vulnerability="finding.vulnerable" :is="`${finding.vulnerable_type}-vulnerability`"/>
</div>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  
  computed: {
    ...mapGetters('finding', [
      'finding'
    ])
  }

}
</script>